import { useForm, Link } from '@inertiajs/react'
import { Building, ArrowLeft, Loader2 } from 'lucide-react'
import { Text } from '@/components/design-system/Text'
import { TextField } from '@/components/design-system/TextField'
import { Button } from '@/components/ui/button'
import { Section } from '@/components/design-system/Section'
import { Banner } from '@/components/design-system/Banner'

interface Props {
  errors?: string[]
  [key: string]: any
}

export default function New({ errors }: Props) {
  const { data, setData, post, processing } = useForm({
    organization: {
      name: ''
    }
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/dashboard/organizations')
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link
          href="/dashboard"
          className="p-2 text-muted-foreground hover:text-accent-foreground hover:bg-accent rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <div>
          <Text as="h1" size="display-small">Nova Organização</Text>
          <Text size="body" color="subdued">Crie uma nova organização para colaborar com sua equipe</Text>
        </div>
      </div>

      {errors && errors.length > 0 && (
        <Banner status="critical" title="Erro ao criar organização:">
          <ul className="space-y-1">
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Banner>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <Section>
          <div className="flex items-center gap-4 mb-6">
            <div className="p-3 bg-blue-100 rounded-lg">
              <Building className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <Text as="h2" size="heading-small">Informações da Organização</Text>
              <Text size="body" color="subdued">Configure os detalhes básicos da sua nova organização</Text>
            </div>
          </div>

          <TextField
            label="Nome da Organização"
            value={data.organization.name}
            onChange={value => setData('organization', { ...data.organization, name: value })}
            placeholder="Ex: Minha Empresa"
            helpText="Este é o nome que aparecerá para todos os membros da organização."
            required
            autoFocus
          />
        </Section>

        <Section>
          <div className="flex gap-4">
            <Button
              type="submit"
              disabled={processing}
            >
              {processing && <Loader2 className="h-4 w-4 animate-spin" />}
              {processing ? 'Criando...' : 'Criar Organização'}
            </Button>

            <Link href="/dashboard">
              <Button type="button" variant="outline">
                Cancelar
              </Button>
            </Link>
          </div>
        </Section>
      </form>
    </div>
  )
}
